module.exports = __webpack_public_path__ + "img/award-logo-illustration.836fa41e.svg";